import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import { toast } from 'react-toastify';

import Spinner from 'components/Spinner';
import { fetchQuickPortOuts, quickPortOutResolve } from 'actions/quickPortOuts';
import { getQuickPortOuts, getPageCount } from 'reducers';
import Pagination from 'components/Pagination/Pagination';
import PortOutsTable from 'components/quick/PortOutsTable';
import FormError from 'components/FormError';

export class QuickPortOuts extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.fetchPortOuts();
  }

  componentDidUpdate(oldProps) {
    const { page } = this.props;
    if (oldProps.page !== page) {
      this.fetchPortOuts();
    }
  }

  fetchPortOuts = () => {
    const { page, fetchQuickPortOuts } = this.props;
    this.setState({ loading: true });

    fetchQuickPortOuts(page)
      .catch((e) => {
        toast.error('Failed to load port outs list');
      })
      .finally(() => this.setState({ loading: false }));
  };

  handlePortAction = (portId, subId, action) => {
    const { quickPortOutResolve } = this.props;
    this.setState({ loading: true });

    quickPortOutResolve(portId, subId, action)
      .then(() => {
        const message = action === 'reject' ? 'Port rejected' : 'Port approved';
        toast.success(message);
      })
      .catch((e) => {
        if (e.errors) {
          if (e.errors._error) {
            toast.error(<FormError error={e.errors._error} />);
            return;
          }

          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { loading } = this.state;
    const { portOuts, pageCount, page } = this.props;
    return (
      <div>
        <h1>Quick Port Outs</h1>
        <PortOutsTable
          portOuts={portOuts}
          handleAction={this.handlePortAction}
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(nextPage) => `/quick/port-outs?page=${nextPage}`}
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });

  return {
    portOuts: getQuickPortOuts(state, page),
    pageCount: getPageCount(state, 'quickPortOuts', 'quickPortOuts_', page),
    page,
  };
};

const mapDispatchToProps = {
  fetchQuickPortOuts,
  quickPortOutResolve,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickPortOuts);
